import { Styled } from './index.styles';
import 'moment/locale/tr';
import { mediaBreakPoints, useMediaScreen } from 'common/theme/media';
import { Link } from '@mui/material';

interface data {
    data: any;
    index: number;
    className?: string;
    imageStyle?: React.CSSProperties;
}

const DynamicBanners = (props: data) => {
    const { data, index, className, imageStyle } = props;

    const media = useMediaScreen();
    const isMobil = mediaBreakPoints.xltablet >= media.width;

    const i = index + 1;
    const webImage = data?.Image?.[`banner${i}`];
    const responsiveImage = data?.ResponsiveImage?.[`banner${i}`];

    return (
        data &&
        webImage &&
        responsiveImage && (
            <Styled className={className} key={index}>
                <Link target="_blank" rel="noreferrer" href={data?.Url} key={'banner-' + data?.ID}>
                    <img style={imageStyle} src={isMobil ? responsiveImage : webImage} alt={`Banner ${i}`} />
                </Link>
            </Styled>
        )
    );
};

export default DynamicBanners;
